import { useParams } from 'react-router-dom';
import { useGetSharedCertificateQuery } from '../../store/api/certificatesApi';
import CertificateArt, { certificateSrc } from '../PayoutCertificates/Certificates/CertificateArt';
import { t } from '../../i18n/i18n';
import './SharedCertificate.scss';

/**
 * `/share-certificates/:certificateId` — what a shared link opens.
 *
 * Genuinely public, like `/p/:accountId`: no session, no shell, nothing off
 * the account behind it. The endpoint answers 200 with `{ error }` for a
 * certificate whose owner has sharing off, so a successful request is not the
 * same thing as a certificate — hence the `data.error` check rather than
 * `isError` alone.
 */
export default function SharedCertificate() {
  const { certificateId } = useParams();
  const { data, isLoading, isError } = useGetSharedCertificateQuery(certificateId);

  const item = data && !data.error ? data : null;

  return (
    <div className="shared-cert">
      <header className="shared-cert__bar">
        <span
          className="shared-cert__logo"
          style={{ '--icon': 'url(/icons/brand-alphacapital.svg)' }}
        />
        <a className="shared-cert__cta" href="https://alphacapitalgroup.uk" rel="noreferrer">
          Alpha Capital
        </a>
      </header>

      <main className="shared-cert__main">
        {isLoading && <div className="shared-cert__frame is-loading" />}

        {!isLoading && item && (
          <>
            <div className="shared-cert__frame">
              <CertificateArt item={item} />
            </div>

            <div className="shared-cert__meta">
              <h1 className="shared-cert__title">{item.title}</h1>
              <p className="shared-cert__by">
                {[item.name, item.plan_type, item.created_at].filter(Boolean).join(' · ')}
              </p>

              {item.link && (
                <a
                  className="shared-cert__download"
                  href={certificateSrc(item.link)}
                  download
                  rel="noreferrer"
                >
                  {t('Download')}
                </a>
              )}
            </div>
          </>
        )}

        {!isLoading && !item && (
          <div className="shared-cert__state">
            <h1 className="shared-cert__state-title">{t('This certificate isn’t available')}</h1>
            <p className="shared-cert__state-text">
              {t(data?.error) ??
                (isError
                  ? t('The link may be wrong, or the certificate may have been removed.')
                  : t('The owner has turned sharing off for this link.'))}
            </p>
          </div>
        )}
      </main>
    </div>
  );
}
